import { render, staticRenderFns } from "./LogOut.vue?vue&type=template&id=05535672&scoped=true&"
import script from "./LogOut.vue?vue&type=script&lang=js&"
export * from "./LogOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05535672",
  null
  
)

export default component.exports